const errors = {
  emailTooLong: {
    th: 'อีเมลต้องยาวไม่เกิน 54 ตัวอักษรเท่านั้น',
    en: "Email can't be longer than 54 letters",
  },
  emailInvalid: {
    th: 'รูปแบบอีเมลไม่ถูกต้อง',
    en: "The email format doesn't look right",
  },
  passwordTooShort: {
    th: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
    en: 'Password must have at least 6 characters',
  },
  passwordTooLong: {
    th: 'รหัสผ่านต้องมีความยาว 6 ถึง 54 ตัวอักษร',
    en: 'Password must be between 6 to 54 characters long',
  },
  passwordInvalid: {
    th: 'รหัสผ่านใช้ได้เฉพาะตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์ทั่วไป',
    en: 'Password can be only letters A-Z, numbers, and symbols',
  },
};

export function getErrorPasswordValidation(password, language) {
  let errorMessages = [];
  if (password.length < 6) {
    errorMessages.push(errors.passwordTooShort[language]);
  } else if (password.length > 54) {
    errorMessages.push(errors.passwordTooLong[language]);
  }
  if (!isASCII(password)) {
    errorMessages.push(errors.passwordInvalid[language]);
  }
  if (errorMessages.length > 0) {
    return errorMessages.join('\n');
  }
  return null;
}

export function getErrorEmailValidation(email, language) {
  let errorMessages = [];
  if (email.length > 54) {
    errorMessages.push(errors.emailTooLong[language]);
  }
  if (!isASCII(email) || !isValidEmail(email)) {
    errorMessages.push(errors.emailInvalid[language]);
  }
  if (errorMessages.length > 0) {
    return errorMessages.join('\n');
  }
  return null;
}

export function isASCII(str) {
  return /^[\x00-\x7F]*$/.test(str);
}

export function isValidEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(String(email).toLowerCase());
}
